export default __webpack_public_path__ + "static/media/slotster.5d754d1c.png";